import React, { useState, useEffect } from 'react';
import { AccordionToggle, ArrowDown} from '../../../lib/domonda-icons';
    
const PopupMessage = ({ children, delay }) => {
  const [show, setShow] = useState(false);
  const [minimize, setMinimize] = useState(true);

  useEffect(() => {
    const timeShow = setTimeout(() => {
      setShow(true)
    }, delay);

    const timeMinimize = setTimeout(() => {
      setMinimize(false)
    }, delay + 100);

    return () => {
      clearTimeout(timeShow);
      clearTimeout(timeMinimize);
    }
  }, []);

  const toggleMinimize = () => {
    setMinimize(!minimize);
  }

  if (!show) {
    return null;
  }

  return (
    <div className={`popupMessage ${minimize ? 'hidden' : 'visible'}`}>
      <span
        className={`accordionToggle`}
        onClick={toggleMinimize}
      >
        <ArrowDown />
      </span>

      <div>
        {children}
      </div>

    </div>
  );
}

export { PopupMessage };

